// extracted by mini-css-extract-plugin
module.exports = {"InputError":"InputError_InputError__1O1Mm","InputError__icon":"InputError_InputError__icon__2JB0W"};